@if (!this.isSelected) {
<div>
  <div class="row">
    @for (image of data.images; track image; let i = $index) {
    <div class="col-sm-{{ colDivision }} mb-3">
      <img
        src="{{ image }}"
        alt="assets/no_image_available.jpg"
        id="galleryImg-{{ i }}"
        class="img-thumbnail rounded"
        (click)="selectedImage = image; rotateCount = ''"
        data-toggle="modal"
        data-target="#imageModal"
      />
    </div>
    } @if (data.images.length <= 0) {
    <div class="col-12">
      <div class="alert alert-primary bergh-text-primary text-center">
        Geen foto's toegevoegd
      </div>
    </div>
    }
  </div>
</div>
} @if (!this.isSelected) {
<button
  style="float: right"
  class="btn bergh-btn-secondary text-white mr-2"
  [ngClass]="{
    'deleteButton-admin-visible': role == '2',
    'deleteButton-employee-hidden': role == '1',
    'deleteButton-customer-hidden': role == '0'
  }"
  [disabled]="data.images.length == 0"
  (click)="selectImage()"
>
  Foto('s) verwijderen
</button>
}

<div class="modal" id="imageModal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content pr-3 pl-3 pb-3">
      <div class="modal-header">
        <div
          class="close px-0"
          id="closeBtn"
          data-dismiss="modal"
          aria-label="Close"
        >
          <i-feather name="x" class="small-icon ml-auto"></i-feather>
        </div>
      </div>
      <div class="row">
        <div class="col-12 image-container position-relative">
          <img
            src="{{ selectedImage }}"
            height="400"
            width="350"
            class="rounded image-view {{ rotateCount }}"
            id="selectedImg"
          />
          <div id="rotate-btn" class="bergh-shadow-one" (click)="rotateImage()">
            <i-feather
              name="rotate-cw"
              class="small-icon text-white"
            ></i-feather>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (this.isSelected) {
<div>
  <div class="row">
    @for (image of data.images; track image; let i = $index) {
    <div class="col-sm-{{ colDivision }} mb-3">
      <a>
        <img
          src="{{ image }}"
          alt="assets/no_image_available.jpg"
          id="galleryImg-{{ i }}"
          class="img-thumbnail rounded" />
        <span
          (click)="clickPicture(i)"
          [ngClass]="{
            'selected-picture': pictures[i].selected,
            overlay: !pictures[i].selected
          }"
          ><img
            src="../../../assets/x-circle.svg"
            style="
              text-align: center;
              justify-content: center;
              position: relative;
              height: 70px;
              width: 70px;
            " /></span
      ></a>
    </div>
    } @if (data.images.length <= 0) {
    <div class="col-12">
      <div class="alert alert-primary bergh-text-primary text-center">
        Geen foto's toegevoegd
      </div>
    </div>
    }
  </div>
</div>
} @if (this.isSelected) {
<button
  style="float: right"
  class="btn bergh-btn-primary text-white mr-2"
  (click)="cancel()"
>
  Annuleren
</button>
} @if (this.isSelected) {
<button
  style="float: right"
  class="btn bergh-btn-secondary text-white mr-2"
  (click)="deleteImages(this.selectedImageIndices)"
>
  Verwijderen
</button>
}
